import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 11 7"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.344 1.746 1.271 5.819a.73.73 0 0 1-.522.213.7.7 0 0 1-.532-.213A.72.72 0 0 1 0 5.292q0-.31.217-.527L4.712.271A.87.87 0 0 1 5.344 0q.362 0 .633.271l4.494 4.494q.209.208.213.523a.7.7 0 0 1-.213.531.72.72 0 0 1-.527.218.72.72 0 0 1-.527-.218z"
    }, null, -1)
  ]))]))
}
export default { render: render }